import React from "react";
import { XCircle, ArrowRight } from "lucide-react";
import { NO_ES_PARA } from "@/content";
import Reveal from "@/components/Reveal";

export default function NoEsPara() {
  return (
    <section
      className="py-16 md:py-24"
      style={{ background: "var(--crema)" }}
      data-testid="section-no-es-para"
    >
      <div className="container-page">
        <div className="mx-auto" style={{ maxWidth: 700 }}>
          <Reveal>
            <h2 className="h2-display" style={{ color: "var(--vino)" }}>
              {NO_ES_PARA.h2}
            </h2>
          </Reveal>

          <ul className="mt-8 space-y-4">
            {NO_ES_PARA.items.map((t, i) => (
              <Reveal
                key={t}
                delay={i * 80}
                as="li"
                className="flex items-start gap-3"
              >
                <XCircle
                  size={22}
                  strokeWidth={2}
                  style={{ color: "#A79FAD", flexShrink: 0, marginTop: 3 }}
                  aria-hidden="true"
                />
                <span className="text-[16px] leading-relaxed" style={{ color: "var(--carbon)" }}>
                  {t}
                </span>
              </Reveal>
            ))}
          </ul>

          <Reveal delay={160} className="mt-9">
            <p
              className="font-display inline-flex items-center gap-2"
              style={{ fontSize: 22, color: "var(--vino)" }}
            >
              <ArrowRight size={22} strokeWidth={2.5} style={{ color: "var(--lima)" }} />
              {NO_ES_PARA.cierre}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
